import { useEffect } from "react";
import { useForm } from "@inertiajs/react";
import { handleDrawerSuccess, hasArrayErrors, hasMatchingId } from "@/lib/drawer-submission";
import { user_path } from "@/routes";

function roleLabel(role = "") {
  return role.replace(/Role$/, "").replace(/([a-z])([A-Z])/g, "$1 $2");
}

export default function UserEditDrawer({ user = {}, roles = [], errors = [], onSuccess, onProcessingChange = null }) {
  const { data, setData, patch, processing } = useForm({
    user: {
      first_name: user.first_name || "",
      last_name: user.last_name || "",
      role: user.role || roles[0] || ""
    }
  });

  useEffect(() => {
    setData({
      user: {
        first_name: user.first_name || "",
        last_name: user.last_name || "",
        role: user.role || roles[0] || ""
      }
    });
  }, [roles, setData, user]);

  useEffect(() => {
    onProcessingChange?.(processing);
  }, [onProcessingChange, processing]);

  const updateUser = (field, value) => {
    setData("user", { ...data.user, [field]: value });
  };

  const submit = (event) => {
    event.preventDefault();

    patch(user_path(user.id), {
      preserveScroll: true,
      onSuccess: (page) => handleDrawerSuccess(
        page,
        (props) => (
          hasMatchingId(props, "edit_user", user.id) ||
          hasArrayErrors(props, "edit_errors")
        ),
        onSuccess
      )
    });
  };

  return (
    <form id="organization-user-edit-form" className="vstack gap-4" onSubmit={submit}>
      {errors.length > 0 ? (
        <div className="alert alert-danger mb-0">{errors.join(", ")}</div>
      ) : null}

      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label fw-semibold">Fornavn</label>
          <input
            type="text"
            className="form-control"
            value={data.user.first_name}
            onChange={(event) => updateUser("first_name", event.target.value)}
            required
          />
        </div>

        <div className="col-md-6">
          <label className="form-label fw-semibold">Efternavn</label>
          <input
            type="text"
            className="form-control"
            value={data.user.last_name}
            onChange={(event) => updateUser("last_name", event.target.value)}
            required
          />
        </div>

        <div className="col-12">
          <label className="form-label fw-semibold">Rolle</label>
          <select
            className="form-select"
            value={data.user.role}
            onChange={(event) => updateUser("role", event.target.value)}
            required
          >
            {roles.map((role) => (
              <option key={role} value={role}>{roleLabel(role)}</option>
            ))}
          </select>
          <div className="form-text">Rollen gælder kun for den aktive organisation.</div>
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <button type="submit" className="btn btn-primary" disabled={processing}>
          {processing ? "Gemmer..." : "Gem ændringer"}
        </button>
      </div>
    </form>
  );
}
